export const formatToCstTime = (localDate = new Date()) => {
	const timeZone = 'America/Chicago';
	const hours = localDate.toLocaleTimeString('en-US', {
		hour12: false,
		hour: '2-digit',
		timeZone,
	});
	const minutes = localDate.toLocaleTimeString('en-US', {
		minute: '2-digit',
		timeZone,
	});
	localDate.setHours(Number(hours));
	localDate.setMinutes(Number(minutes));
	return localDate;
};
